module.exports = __webpack_public_path__ + "img/about-img-3.e9c38709.png";